<template lang="pug">
  #CustomerTempTextModel.CustomerModel.CustomerModel-tempTextModel(
    :class="{ 'CustomerModel-active': showModel }",
    :style="[{Zindex: Zindex}, modelCSS]",
  )
    .model-content
      .text-center.mt-2
        h4.text-center.mb-0 {{ title }}
        small.text-center.redRemind *發送後無法收回
      .content.px-3.pb-3.pt-2.mb-2
        template(
            v-for="(temp,index) in finalSendTemps"
          )
            //- 文字
            b-card.border-0.customerCard.tempInput(
              bg-variant="light",
              v-if='temp.push_format.type === "text"'
            )
              b-form-textarea(
                rows="5",
                v-model="temp.push_format.text"
              )
              small.text-muted.text-right.d-block 文字數：{{ temp.push_format.text ? temp.push_format.text.length : 0 }}
            //- 影像地圖
            image-map-input(
              v-if='temp.push_format.type === "imageMap"',
              :key="temp.id",
              :index='index',
              :originalData="temp",
              :selectMode="false",
              :deleteMode="true"
            )
            //- 橫向捲軸
            carousel-input(
              v-if='temp.push_format.type === "carousel"',
              :key="temp.id",
              :index='index',
              :originalData="temp",
              :selectMode="false",
              :deleteMode="true"
            )
            //- 影片
            video-input(
              v-if='temp.push_format.type === "video"',
              :key="temp.id",
              :index='index',
              :originalData="temp",
              :selectMode="false",
              :deleteMode="true"
            )
            //-圖片
            image-input(
              v-if='temp.push_format.type === "image"',
              :key="temp.id",
              :index='index',
              :originalData="temp",
              :selectMode="false",
              :deleteMode="true"
            )
      .px-4.mb-3
        .row
          .col-6
            button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
              type="button",
              @click="submitHandler()",
              style="border: 0.2rem solid #000;border-radius: 50px;padding: 5px; box-shadow: 0.15rem 0.15rem 0 #00000033;"
            ) 確定
          .col-6
            button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
              type="button",
              @click="closeModel()",
              style="border: 0.2rem solid #000;border-radius: 50px;padding: 5px; box-shadow: 0.15rem 0.15rem 0 #00000033;"
            ) 取消

</template>

<script>
import { mapState } from 'vuex';
import IconCloseUrl from '@/assets/images/icon/icon_close.png';

// 模板顯示部分
import textInput from '@/components/modalTemplate/messageText/textInput.vue';
import imageMapInput from '@/components/modalTemplate/messageImageMap/imageMapInput.vue';
import carouselInput from '@/components/modalTemplate/messageCarousel/carouselInput.vue';
import videoInput from '@/components/modalTemplate/messageVideo/videoInput.vue';
import imageInput from '@/components/modalTemplate/messageImage/imageInput.vue';

const _ = require('lodash');

export default {
  name: 'TempSendPreviewModel',
  components: {
    textInput,
    imageMapInput,
    carouselInput,
    videoInput,
    imageInput
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    Zindex: {
      type: String,
      default: '15px'
    },
    modelCSS: {
      type: Object,
      default: null
    },
    previewTemps: {
      type: Array,
      require: true
    },
    user: {
      type: [Object, null],
      default: null
    },
    multicastPush: {
      type: Boolean,
      default: false
    },
    users: {
      type: [Array, Object],
      default: null
    }
  },
  data() {
    return {
      iconUrl: {
        IconClose: IconCloseUrl
      },
      showModel: false,
      finalSendTemps: []
    };
  },
  mounted() {
    const vm = this;
    vm.$EventBus.$on('openTempSendPreviewModel', () => {
      vm.openModel();
    });
  },
  methods: {
    initHandler() {
      this.finalSendTemps = null;
      this.finalSendTemps = _.cloneDeep(this.previewTemps);
    },
    openModel() {
      this.initHandler();
      this.showModel = true;
    },
    closeModel() {
      this.$emit('scrollToTarget');
      this.finalSendTemps = null;
      this.showModel = false;
      $('.icon-back').removeClass('d-none');
    },
    async submitHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '模板送出中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      const data = await _.map(vm.finalSendTemps, (val) => ({
          id: val.id,
          template: val.type,
          text: val.push_format.type === 'text' ? val.push_format.text : null
        }));

      let sendData;

      // 群發
      if (vm.multicastPush) {
        sendData = {
          to: _.map(vm.users, (val) => val.member_line_uuid || val.line_uuid),
          templates: data
        };
      } else if (!vm.multicastPush) {
        sendData = {
          member_uuid: vm.user.member_uuid || vm.user.member_line_uuid,
          templates: data
        };
      } else {
        return;
      }

      vm.$store.dispatch(`sa_chat/${vm.multicastPush ? 'templatesMulticastPushHandler' : 'templatesPushHandler'}`, sendData)
        .then(() => {
          vm.$emit('closeModelHandler');
          vm.closeModel();
          vm.$swal.close();
        });
    },
    deleteTempHandler({ id, template }) {
      const vm = this;
      if (vm.finalSendTemps.length === 1) {
        vm.$swal.fire({
          icon: 'error',
          title: '至少需要選擇一則模板'
        });
      } else {
        vm.$swal.fire({
          title: '您確定取消傳送這個模板?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          reverseButtons: true,
          customClass: {
            confirmButton: 'custom-swal-btn',
            cancelButton: 'custom-swal-btn'
          }
        }).then((result) => {
          if (result.value) {
            const finalSendTemps_key = _.findKey(vm.finalSendTemps, (val) => val.id === id && val.type === template);
            vm.finalSendTemps.splice(finalSendTemps_key, 1);
          }
        });
      }
    }
  },
  computed: {
    ...mapState({
      temps: (state) => state.sa_temp.temps,
      pagination: (state) => state.sa_temp.pagination
    })
  },
  beforeDestroy() {
    this.$EventBus.$off('openTempSendPreviewModel');
  }
};
</script>

<style scoped>
.model-content {
  overflow: scroll;
  border-radius: 15px;
  background-color: #FFF;
}
</style>
